import { render, staticRenderFns } from "./WidgetController1.vue?vue&type=template&id=7be2a781"
import script from "./WidgetController1.vue?vue&type=script&lang=js"
export * from "./WidgetController1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports